/**
 * Resize Listener
 * debounces window width changes
 * sends event "lichen:resize"
 * any component can listen to event and adjust to new size
 */

var initializeResizeListener = function () {
	var lichenResizeTimer = false;
	var lastWidth = window.innerWidth;
	window.addEventListener(
		'resize',
		function () {
			clearTimeout(lichenResizeTimer);
			lichenResizeTimer = setTimeout(function () {
				var width = window.innerWidth;
				if (lastWidth !== width) {
					var event = new CustomEvent('lichen:resize', { detail: { width: width } });
					document.dispatchEvent(event);
				}
			}, 300);
		},
		false
	);
};

document.addEventListener('lichen:loaded', initializeResizeListener);

export default initializeResizeListener;
